import React, {Component} from 'react'
import {ReactComponent as PersonIcon} from '@shop/icon-fonts/optimized/person-mid.svg'
import {ReactComponent as AngleDownIcon} from '@shop/icon-fonts/optimized/angle-down-small.svg'
import * as SC from './Account.styled'
import {InlinedPrimaryIcon, PrimaryIcon} from '../Icon/Icon.styled'
import AccountFlyout from './AccountFlyout'
import {AccessibleText, DEVICE_TYPES} from '../../utils'
import Link from '../Link'
import AppContext from '../../context/AppContext'

export const ACCOUNT_ID = 'srh-account'

class AccountComponent extends Component {
  static contextType = AppContext

  constructor(props) {
    super(props)
    this.state = {
      showFlyout: false
    }
    this.timeOutId = null
  }

  onBlur = () => {
    this.timeOutId = setTimeout(() => {
      this.setState({showFlyout: false});
    });
  }

  onFocus = () => {
    clearTimeout(this.timeOutId);
  }

  flyoutHoverInHandler = () => {
    this.setState({showFlyout: true});
  }

  flyoutHoverOutHandler = () => {
    this.setState({showFlyout: false});
  }

  handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      const {showFlyout} = this.state;
      this.setState({showFlyout: !showFlyout});
    } else if (event.key === 'Escape') {
      this.setState({showFlyout: false});
    }
  }

  // TODO: HREF attr for links should be provided from BE(?)
  render() {
    const {showFlyout} = this.state
    const {translations, device} = this.context
    const isAccessibleText = device !== DEVICE_TYPES.DESKTOP && device !== DEVICE_TYPES.LAPTOP
    const TextComponent = isAccessibleText ? AccessibleText : SC.LinkText

    return (
      <SC.AccountWrapper
        tabIndex="0"
        id={ACCOUNT_ID}
        onKeyUp={this.handleKeyUp}
        onMouseEnter={this.flyoutHoverInHandler}
        onMouseLeave={this.flyoutHoverOutHandler}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        aria-describedby="shopHeaderAccountFlyoutDescription"
        aria-haspopup="true"
        aria-expanded={showFlyout}
        role="menu"
      >
        <AccessibleText id="shopHeaderAccountFlyoutDescription">
          {translations.get('shop.header.account.flyout.accessible.description')}
        </AccessibleText>
        <Link
          href="/account"
          withPadding={false}
          noWrap
          isAccountLink
        >
          <PrimaryIcon style={{marginRight: isAccessibleText ? '0' : '5px'}}>
            <PersonIcon />
          </PrimaryIcon>
          <TextComponent id="shopHeaderAccountLink">
            {translations.get('shop.header.top.account')}
          </TextComponent>
          <InlinedPrimaryIcon>
            <AngleDownIcon />
          </InlinedPrimaryIcon>
        </Link>
        <AccountFlyout
          showFlyout={showFlyout}
          aria-hidden={!showFlyout}
        />
      </SC.AccountWrapper>
    )
  }
}

export default AccountComponent
